module.exports = __webpack_public_path__ + "static/img/hero_shape_5.dc2c6ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hero_shape_5.png
// module id = 9n64
// module chunks = 0